import { Box } from "@mui/material";
import React from "react";

export interface TagStatusProps {
  status: number;
}

const STATUS_LABELS: Record<number, string> = {
  1: "Aguardando carregamento",
  2: "Carregamento finalizado",
  5: "Aguardando descarga",
  6: "Descarregamento finalizado",
  23: "Carga/descarga em andamento",
};

const STATUS_COLORS: Record<number, { color: string; backgroundColor: string }> =
  {
    1: { color: "#D91F05", backgroundColor: "#FFD8D2" },
    2: { color: "#0BB873", backgroundColor: "#D3FEED" },
    5: { color: "#D91F05", backgroundColor: "#FFD8D2" },
    6: { color: "#0BB873", backgroundColor: "#D3FEED" },
    23: { color: "#FAD217", backgroundColor: "#FFF2D1" },
  };

const TagStatus: React.FC<TagStatusProps> = (props) => {
  const styles = STATUS_COLORS[props.status] ?? {
    color: "#626166",
    backgroundColor: "#EEF0F5",
  };

  return (
    <Box
      sx={{
        display: "inline",
        padding: "0.6rem 1rem",
        width: "100%",
        borderRadius: "0.7rem",
        color: styles.color,
        backgroundColor: styles.backgroundColor,
      }}
    >
      {STATUS_LABELS[props.status] ?? "Outros"}
    </Box>
  );
};

export default TagStatus;
